import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild
} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-landing-header',
  templateUrl: './landing-header.component.html',
  styleUrls: ['./landing-header.component.scss']
})
export class LandingHeaderComponent implements OnInit {
  @ViewChild('navbar', { static: true }) navbar!: ElementRef;

  isLandingRoute: boolean = false;
  isCatalogRoute: boolean = false;

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.checkCurrentRoute(this.router.url); // inicialización

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.checkCurrentRoute(event.urlAfterRedirects);
      });
  }

  private checkCurrentRoute(url: string): void {
    this.isLandingRoute = url === '/landing';
    this.isCatalogRoute = url === '/catalog';
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const scrollY = window.scrollY;
    const navbarEl = this.navbar.nativeElement;

    if (scrollY > 10) {
      navbarEl.classList.add('sticky-navbar');
    } else {
      navbarEl.classList.remove('sticky-navbar');
    }
  }
}
